import * as React from 'react';
import type { SVGProps } from 'react';

const SvgMousePointer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="24"
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.275 13.1904L14.309 13.2335C14.5983 13.6002 14.6923 13.9648 14.6923 14.2758C14.6923 15.1408 13.9979 15.87 13.1077 15.87H10.6991L12.4233 19.9657C12.7172 20.6621 12.4059 21.4838 11.6945 21.7917C11.6941 21.7919 11.6936 21.7921 11.6932 21.7923L9.18638 22.8843L9.18538 22.8847C9.01585 22.9584 8.82838 23 8.63344 23C8.45415 23 8.28287 22.9651 8.12725 22.9048L8.11698 22.9008L8.10679 22.8966C7.76495 22.7555 7.49588 22.4853 7.35402 22.1481L14.275 13.1904ZM14.275 13.1904L14.2366 13.1514L3.68082 2.42691L3.64067 2.38612L3.59613 2.35018C2.54342 1.50065 1 2.28914 1 3.58083V18.237C1 19.1019 1.69441 19.8312 2.58462 19.8312C2.94911 19.8312 3.35069 19.7018 3.64747 19.4182L5.50977 17.7691M14.275 13.1904L5.50977 17.7691M5.50977 17.7691L7.3535 22.1468L5.50977 17.7691Z"
      fill="#FFB156"
      stroke="black"
      strokeWidth="2"
    />
  </svg>
);
export default SvgMousePointer;
